<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="  overflow: auto; padding-bottom: 53px"
  >
    <template slot="title">
      <div style="width: 100%">
        <span>{{ title }}</span>
        <span
          style="display: inline-block; width: calc(100% - 51px); padding-right: 10px; text-align: right"
        >
          <a-button
            @click="toggleScreen"
            icon="appstore"
            style="height: 20px; width: 20px; border: 0px"
          ></a-button>
        </span>
      </div>
    </template>
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" :colon="false">
        <a-form-item
          label="规则名称："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="20"
            type="text"
            placeholder="请输入"
            v-model="view.ruleName"
            v-decorator="['ruleName', validatorRules.ruleName]"
          />
        </a-form-item>
        <a-form-item
          label="触发方式："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            placeholder="请选择"
            v-model="view.ruleType"
            v-decorator="['ruleType', validatorRules.ruleType]"
          >
            <a-select-option
              v-for="item in selectData"
              :key="item.id"
              :value="item.name"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          label="事件名称："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="20"
            type="text"
            placeholder="请输入"
            v-model="view.eventName"
            v-decorator="['eventName', validatorRules.eventName]"
          />
        </a-form-item>
        <a-form-item
          v-if="view.ruleType == '定时'"
          label="发送时间Cron:"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="20"
            type="text"
            placeholder="请输入"
            v-model="view.sendTime"
            v-decorator="['sendTime', validatorRules.sendTime]"
          />
        </a-form-item>

        <a-form-item
          label="数据列表："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="20"
            type="text"
            placeholder="请输入"
            v-model="view.dataParList"
            v-decorator="['dataParList', validatorRules.dataParList]"
          />
        </a-form-item>
        <a-form-item
          label="发送对象："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            placeholder="请选择"
            v-model="view.sendObj"
            mode="multiple"
            autoClearSearchValue
            v-decorator="['sendObj', validatorRules.sendObj]"
          >
            <a-select-option
              v-for="item in sendData"
              :key="item.id"
              :value="item.name"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          label="发送内容模板："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            placeholder="请输入"
            :auto-size="{ minRows: 2, maxRows: 6 }"
            v-model="view.content"
            v-decorator="['content', validatorRules.content]"
          />
        </a-form-item>
        <a-form-item
          label="规则备注："
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            placeholder="请输入"
            :auto-size="{ minRows: 2, maxRows: 6 }"
            v-model="view.ruleRemark"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit()" type="primary" :loading="confirmLoading"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import JImageUpload from '../../../components/jeecg/JImageUpload';
import { getFileIOByMediaId } from '@/api/api';
import { fstat } from 'fs';

export default {
  name: 'numberModal',
  components: {
    JImageUpload
  },
  props: {
    saveData: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      view: {
        ruleName: '',
        ruleType: '',
        eventName: '', //事件名称
        sendTime: '',
        dataParList: '',
        sendObj: [],
        content: '',
        ruleRemark: ''
      },
      validatorRules: {
        ruleName: {
          rules: [{ required: true, message: '请输入规则名称!' }]
        },
        ruleType: {
          rules: [{ required: true, message: '请选择触发方式' }]
        },
        sendTime: {
          rules: [{ required: true, message: '请输入发送时间Cron' }]
        },
        eventName: {
          rules: [{ required: true, message: '请输入事件名称' }]
        },
        dataParList: {
          rules: [{ required: true, message: '请输入数据列表!' }]
        },
        sendObj: {
          rules: [{ required: true, message: '请选择发送对象' }]
        },
        content: {
          rules: [{ required: true, message: '请输入发送内容模板' }]
        }
      },
      modalWidth: 800,
      drawerWidth: 700,
      modaltoggleFlag: true,
      disableSubmit: false,
      title: '新增',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      fileList: [],
      selectData: [
        {
          id: '事件',
          name: '事件'
        },
        {
          id: '定时',
          name: '定时'
        }
      ],
      sendData: [
        {
          id: '杨羊',
          name: '杨羊'
        },
        {
          id: '丁健',
          name: '丁健'
        },
        {
          id: '王康岚',
          name: '王康岚'
        },
        {
          id: '周娇',
          name: '周娇'
        }
      ],
      dataList: [],
      selectedRowKeys: [],
      loading: false
    };
  },
  // inject: ['reload'],
  methods: {
    onChange(e) {
      console.log(e);
    },
    //窗口最大化切换
    toggleScreen() {
      if (this.modaltoggleFlag) {
        this.modalWidth = window.innerWidth;
      } else {
        this.modalWidth = 800;
      }
      this.modaltoggleFlag = !this.modaltoggleFlag;
    },
    add() {
      this.resetScreenSize(); // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
      this.disableSubmit = false;
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth < 500) {
        this.drawerWidth = screenWidth;
      } else {
        this.drawerWidth = 700;
      }
    },

    _getFileList(fileList, flag) {
      console.log(fileList, flag);
      if (fileList.length > 0 && fileList) {
        let mediaId = fileList[fileList.length - 1].response.result.mediaId;
        getFileIOByMediaId({ mediaId }).then(res => {
          if (res.success) {
            this.avatar_mediaid = process.env.VUE_APP_CMS_MINIOURL + res.result;
            console.log(this.avatar_mediaid);
            this.form.setFieldsValue({
              [flag]: this.avatar_mediaid
            });
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    onSelectChange() {},
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let newObj = this.view;
          let obj = { ...newObj }; //深拷贝 不影响原始数据
          let newStr = '';
          if (obj.sendObj.length > 0) {
            obj.sendObj.forEach(ele => {
              newStr += ele + '、';
            });
          }
          obj.sendstr = newStr;
          this.$emit('saveData', obj);
          this.visible = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
